<template>
  <v-radio-group
    v-bind="this.$attrs"
    @change="$emit('change', type)"
    v-model="type"
    hide-details="auto"
    row
    class="shrink mt-0 pt-0"
  >
    <p class="my-0 mr-2 d-flex align-center">Mục:</p>
    <v-radio label="Về học tập" hide-details value="commendation"></v-radio>
    <v-radio label="Về nội dung khác" hide-details value="violation"></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    type: ''
  }),
  props: {
    violation: {
      type: String,
      default: 'commendation'
    }
  },
  created() {
    this.type = this.violation
    this.$emit('change', this.type)
  },
  watch: {
    violation: {
      handler(val) {
        if (val) {
          this.type = this.violation
          this.$emit('change', this.type)
        }
      },
      immediate: true
    }
  }
}
</script>
